import React from 'react';
import { useContent } from 'context/ContentContext';

// The canonical host. www.transpiled.com 301-redirects here, and a backlink
// through a redirect is worth less than a direct one (#656).
export const TRANSPILED_URL = 'https://transpiled.com';

const COPY = {
  en: {
    lead: 'Web design and development by',
    title: 'Transpiled: web design and development',
  },
  es: {
    lead: 'Diseño y desarrollo web por',
    title: 'Transpiled: diseño y desarrollo web',
  },
};

/**
 * The "site by Transpiled" credit. Unstyled on purpose: it inherits the text
 * styles of whatever footer renders it. The copy lives here, not in the CMS,
 * so the backlink cannot be edited away (#656).
 */
const SiteCredit = () => {
  const { language } = useContent();
  const copy = COPY[language] || COPY.en;

  return (
    <p>
      {copy.lead}{' '}
      {/* eslint-disable-next-line react/jsx-no-target-blank -- `noreferrer`
          would hide the referrer from transpiled.com analytics; `noopener`
          alone closes the window.opener hole in every supported browser. */}
      <a
        href={TRANSPILED_URL}
        target="_blank"
        rel="noopener"
        title={copy.title}
      >
        Transpiled
      </a>
    </p>
  );
};

export default SiteCredit;
